export interface JiraProjectDTO {
  id: string;
  key: string;
  name: string;
  style?: ProjectStyle;
  projectTypeKey?: ProjectTypeKey;
}

export enum ProjectStyle {
  CompanyManaged = 'classic',
  TeamManaged = 'next-gen',
  None = 'none',
}

export enum ProjectTypeKey {
  Software = 'software',
  ServiceDesk = 'service_desk',
  Business = 'businees',
  None = 'none',
}

export class JiraProject {
  private readonly id: string;
  private readonly key: string;
  private readonly name: string;
  private readonly style: ProjectStyle;
  private readonly projectTypeKey: ProjectTypeKey;

  constructor({ id, key, name, style, projectTypeKey }: JiraProjectDTO) {
    this.id = id;
    this.key = key;
    this.name = name;
    this.style = style ?? ProjectStyle.None;
    this.projectTypeKey = projectTypeKey ?? ProjectTypeKey.None;
  }

  getId(): string {
    return this.id;
  }

  getName(): string {
    return this.name;
  }

  getKey(): string {
    return this.key;
  }

  isCompanyManaged(): boolean {
    return this.style === ProjectStyle.CompanyManaged;
  }

  isTeamManaged(): boolean {
    return this.style === ProjectStyle.TeamManaged;
  }

  isSoftwareProjectType(): boolean {
    return this.projectTypeKey === ProjectTypeKey.Software;
  }
}
